import { Accordion, AccordionDetails, AccordionSummary, Box, Skeleton, Typography } from '@mui/material'
import React, { useState } from 'react'
import { ExpandMore } from '@mui/icons-material'
import Item from '../submodules/Item'

const NewItems = (props) => {

  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Box>
      <Accordion expanded={isExpanded} key={"NewItems"} sx={{my: .5,}}>
        <AccordionSummary
          aria-controls="new-items-content"
          expandIcon={<ExpandMore />}
          id="new-items-header"
          onClick={() => {setIsExpanded(!isExpanded)}}
        >
          <Typography variant="h2" fontSize={20} fontWeight="bold">New Items</Typography>
        </AccordionSummary>
        {
          props.items.length === 0 ? (
            <Skeleton variant="rectangular" sx={{display: "flex", flex: 1,}} height={414} />
          ) : (
            <AccordionDetails>
              <Box>
                <Box sx={{display: "flex", flexWrap: "wrap",}}>
                  {props.items.map(item => (
                    <Item key={item.id} item={item} />
                  ))}
                </Box>
              </Box>
            </AccordionDetails>
          )
        }
      </Accordion>
    </Box>
  )
}

export default NewItems